<template>
  <v-container
    fluid
    class="fill-height"
    style="min-width: 370px; min-height: 500px"
  >
    <span class="body-1" style="position: absolute; top: 15px; left: 15px">{{
      $route.path
    }}</span>
    <v-row justify="center" align="center" class="fill-height">
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
        class="text-center"
        align-self="center"
      >
        <p class="display-2 font-weight-thin">Page Not Found</p>
        <v-img
          :src="require('../assets/images/page-not-found.svg')"
          width="100%"
          class="mx-auto"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>

<style scoped></style>
